// extracted by mini-css-extract-plugin
export var attachButton = "_i6-8";
export var sendButton = "_i6-2";
export var sendDisabled = "_i6-4";
export var sendEnabled = "_i6-3";
export var sendIcon = "_i6-6";
export var sendIconDisabled = "_i6-7";
export var sendStreaming = "_i6-5";
export var textarea = "_i6-1";
export var wrapper = "_i6-0";